import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import type { UserFlag } from '@api/Entities/User/UserFlag';
import clsx from 'clsx';

export type UserFlagButtonProps = {
  flag: UserFlag;
  selected?: boolean;
  onToggle?: (flag: string) => void;
  className?: string;
};

export const UserFlagButton = ({
  flag,
  selected = false,
  onToggle,
  className,
}: UserFlagButtonProps) => {
  const color = flag.getFlagColor();
  const defaultClassList = ['border', 'border-' + color, 'p-1'];

  if (selected) {
    defaultClassList.push('text-white', 'bg-' + color);
  } else {
    defaultClassList.push('text-' + color);
  }

  if (!onToggle) {
    defaultClassList.push('cursor-default');
  }

  const mergedClassList = clsx(defaultClassList, className);

  return (
    <OverlayTrigger
      placement="top"
      key={color}
      overlay={<Tooltip id="tooltip-top">{flag.getFlagMeaning()}</Tooltip>}
    >
      <Button
        onClick={onToggle ? () => onToggle(color) : undefined}
        variant="white"
        size="sm"
        className={mergedClassList}
      >
        <FontAwesomeIcon className="d-block" icon={faFlag} />
      </Button>
    </OverlayTrigger>
  );
};
